import React from "react";

/**
 * A reusable confirmation modal component
 * @param {Object} props - Component props
 * @param {Function} props.onConfirm - Function to call when confirmation is approved
 * @param {Function} props.onCancel - Function to call when confirmation is cancelled
 * @param {string} props.title - Optional title override (defaults to "Confirmation de suppression")
 * @param {string} props.message - Optional message override (defaults to "Êtes-vous sûr de vouloir supprimer cet utilisateur ?")
 * @param {string} props.confirmText - Optional confirm button text override (defaults to "Oui, supprimer")
 * @param {string} props.cancelText - Optional cancel button text override (defaults to "Annuler")
 */
const ConfirmationModal = ({
    onConfirm,
    onCancel,
    title = "Confirmation de suppression",
    message = "Êtes-vous sûr de vouloir supprimer cet utilisateur ?",
    confirmText = "Oui, supprimer",
    cancelText = "Annuler"
}) => {
    return (
        <div className="confirmation-modal d-flex flex-column gap20">
            <h3>{title}</h3>
            <p>{message}</p>
            <div className="d-flex justify-content-end gap10">
                <button
                    onClick={onCancel}
                    className="border-0 bg-soft-grey radius5 px-20 py-10 white hoverOpacity"
                >
                    {cancelText}
                </button>
                <button
                    onClick={onConfirm}
                    className="border-0 bg-pink radius5 px-20 py-10 white hoverOpacity"
                >
                    {confirmText}
                </button>
            </div>
        </div>
    );
};

export default ConfirmationModal;
